import { List } from "../Components/index.js";

export default [
    {
        path: "/admin/account/setting/group",
        component: List,
        name: "account.setting.group",
        meta: {
            requiresAuth: true,
        },
    },
];
